import { environment } from '../../../../../environments/environment.staging';
import { Component, OnInit, Input, EventEmitter, Output, Sanitizer } from '@angular/core';
import { Lilate, LilateStatus } from '../../model/lilate.model';
import { LilateService } from '../../service/lilate.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-identity-check',
  templateUrl: './identity-check.component.html',
  styleUrls: ['./identity-check.component.scss']
})
export class IdentityCheckComponent implements OnInit {
  @Input() lilate: Lilate;
  @Output() close = new EventEmitter();

  issue = 'identity_issue';
  identityCard;
  report: boolean = false;
  constructor(
    private lilateService: LilateService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    this.lilateService.getLilateIdentity(this.lilate.id).subscribe(
      identity => {
        this.identityCard = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(new File([identity], 'identitycard')));
      }
    )
  }

  closeModal() {
    this.close.emit();
  }

  reportIssueLilate() {
    this.lilateService.patch({ status : this.issue }, this.lilate.id).subscribe(
      () => {
        this.closeModal();
      }
    );
  }
}
